<template>
  <div id="pageRoot">
    <p id="text01">
      Señala en cada renglón la palabra del cuento que aparece dibujada.
    </p>
    <p id="text02">PELOTA</p>
    <p id="text03">PELO</p>
    <p id="text04">PERA</p>
    <p id="text05">PERRO</p>

    <label class="toggleButtonContainer pageElement" id="toggle01"
      >MELÓN
      <input
        type="radio"
        name="mesa"
        ref="1-1"
        v-on:change="saveOption('radios', 1, 1)"
        :onload="loadOption('radios', 1, 1)"
      />
      <span class="toggleButton"></span>
    </label>
    <label class="toggleButtonContainer pageElement" id="toggle02"
      >MESA
      <input
        type="radio"
        name="mesa"
        ref="1-2"
        v-on:change="saveOption('radios', 1, 2)"
        :onload="loadOption('radios', 1, 2)"
      />
      <span class="toggleButton"></span>
    </label>
    <label class="toggleButtonContainer pageElement" id="toggle03"
      >MENTA
      <input
        type="radio"
        name="mesa"
        ref="1-3"
        v-on:change="saveOption('radios', 1, 3)"
        :onload="loadOption('radios', 1, 3)"
      />
      <span class="toggleButton"></span>
    </label>
    <label class="toggleButtonContainer pageElement" id="toggle04"
      >MEJILLÓN
      <input
        type="radio"
        name="mesa"
        ref="1-4"
        v-on:change="saveOption('radios', 1, 4)"
        :onload="loadOption('radios', 1, 4)"
      />
      <span class="toggleButton"></span>
    </label>

    <div id="dog" class="basicItem01">
      <img
        src="/pages/img/sordo/svgPage63Dog.svg"
        class="pageElement"
        style="width: 100%; height: 100%"
      />
    </div>
    <div id="table" class="basicItem01">
      <img
        src="/pages/img/sordo/svgPage63Table.svg"
        class="pageElement"
        style="width: 100%; height: 100%"
      />
    </div>

    <div id="bubbleText01">
      <p id="text10">
        ¡Presta atención!<br /><br />
        Las palabras son muy similares y las puedes confundir.
      </p>
      <img
        src="/pages/img/svgTextBubble01.svg"
        class="pageElement"
        style="width: 100%; height: 100%"
      />
    </div>

    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
    <span class="footer-page footer-read"></span>
    <div class="pageSVG">
      <img
        src="/pages/img/sordo/svgPage63.svg"
        class="pageElement"
        style="width: 100%; height: auto"
      />
    </div>
    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
  </div>
</template>
<style scoped>
#bubbleText01 {
  position: absolute;
  width: 350px;
  height: 300px;
  margin-top: 35%;
  margin-left: 60%;
  z-index: 3;
  background-color: transparent;

  animation-name: appearBubble;
  animation-duration: 0.5s;
  animation-timing-function: cubic-bezier(0, 0, 0.3, 1.3);
}
@keyframes appearBubble {
  from {
    margin-left: 70%;
    margin-top: 50%;
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
#dog {
  /* dog */
  position: absolute;
  left: 8.59%;
  right: 70.22%;
  top: 23.18%;
  bottom: 57.26%;
}
#table {
  position: absolute;
  left: 12.5%;
  right: 70.79%;
  top: 59.51%;
  bottom: 22.56%;
}
#text01 {
  /* Señala en cada renglón la palabra del cuento que aparece dibujada. */

  position: absolute;
  left: 8.59%;
  right: 16.6%;
  top: 8.2%;
  bottom: 87.24%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 33px;

  color: #000000;
}

#text02 {
  /* PELOTA */

  position: absolute;
  left: 40.74%;
  right: 47.24%;
  top: 19.79%;
  bottom: 74.26%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 33px;
  line-height: 45px;

  color: #000000;
}

#text03 {
  /* PELO */

  position: absolute;
  left: 40.74%;
  right: 51.15%;
  top: 26.83%;
  bottom: 67.22%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 33px;
  line-height: 45px;

  color: #000000;
}

#text04 {
  /* PERA */

  position: absolute;
  left: 40.74%;
  right: 51.34%;
  top: 33.75%;
  bottom: 60.3%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 33px;
  line-height: 45px;

  color: #000000;
}

#text05 {
  /* PERRO */

  position: absolute;
  left: 40.74%;
  right: 48.79%;
  top: 40.8%;
  bottom: 53.26%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 33px;
  line-height: 45px;

  color: #000000;
}

#text06 {
  /* MELÓN */

  position: absolute;
  left: 40.06%;
  right: 47.92%;
  top: 53.52%;
  bottom: 40.54%;
  margin: 0px;
  z-index: 3;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 33px;
  line-height: 45px;
  color: #000000;
}

#text07 {
  /* MESA */

  position: absolute;
  left: 40.04%;
  right: 49.71%;
  top: 60.55%;
  bottom: 33.46%;
  margin: 0px;
  z-index: 3;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 33px;
  line-height: 45px;
  color: #000000;
}

#text08 {
  /* MENTA */

  position: absolute;
  left: 40.04%;
  right: 47.95%;
  top: 67.45%;
  bottom: 26.56%;
  margin: 0px;
  z-index: 3;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 33px;
  line-height: 45px;
  color: #000000;
}

#text09 {
  /* MEJILLÓN */

  position: absolute;
  left: 40.04%;
  right: 44.53%;
  top: 74.48%;
  bottom: 19.53%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 33px;
  line-height: 45px;

  color: #000000;
}

#text10 {
  /* ¡Presta atención! Las palabras son muy similares y las puedes confundir. */
  position: absolute;
  width: 78%;
  height: 60%;
  left: 11%;
  top: 17%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 26px;
  line-height: 29px;
  text-align: center;

  color: #ffffff;
}

#toggle01 {
  /* Ellipse 3 */

  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 353px;
  top: 412.86px;
  z-index: 3;
}

#toggle02 {
  /* Ellipse 3 */

  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 353px;
  top: 466.95px;
  z-index: 3;
}

#toggle03 {
  /* Ellipse 3 */

  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 353px;
  top: 520.09px;
  z-index: 3;
}

#toggle04 {
  /* Ellipse 3 */

  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 353px;
  top: 574.18px;
  z-index: 3;
}
</style>
<script>
export default {
	data() {
		return {
			videos: ["p63-65/V41.mp4", "p63-65/V42.mp4"],
		};
	},

  methods: {
    dbId(name, group) {
      return `${this.$parent.pageID()}-${name}-${group}`;
    },
    async loadOption(name, group, option) {
      var id = this.dbId(name, group);

      var value = await this.$db.options
        .get({
          id: id,
        })
        .catch(function (error) {
          console.log("error getting option" + error);
        });
      if (value === undefined) return;
      console.log(value);

      this.$refs[group + "-" + option].checked = value.option == option;

      console.log(
        "option loaded: " +
          id +
          ", option:" +
          option +
          ", selected:" +
          value.option
      );
    },
    saveOption(name, group, option) {
      var id = this.dbId(name, group);

      this.$db.options
        .put({
          id: id,
          option: option,
        })
        .catch(function (error) {
          console.log("error saving option" + error);
        });

      console.log("option saved: " + id + ", " + option);
    },
  },
};
</script>